'use strict';
(function () {
  angular.module('pentaApp').factory('queue.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/queue', null, { query: { isArray: true, cache: true } });
  }

})();